import RoleEnum from '@/common/role.enum'

// สิทธิ์สำหรับ Report ทั่วไป
export default [
  RoleEnum.SUPER_ADMIN,
  RoleEnum.SUPERVISOR,
  RoleEnum.MANAGER,
  RoleEnum.MANAGEMENT
]

// สิทธิ์สำหรับ Categories Report และ Complain Report (Super Admin เท่านั้น)
export const restrictedReportPermission = [
  RoleEnum.SUPER_ADMIN
]
